// extracted by mini-css-extract-plugin
module.exports = {"app-container":"App_app-container__Ap5lg","container":"App_container__1bY78","sidebar":"App_sidebar__lIfYS","sidebar-open":"App_sidebar-open__1VxL1","content":"App_content__1yR23"};